import styled from "styled-components";

export const HeroHeadingContainer = styled.h2`
  font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_700};
  color: ${({ theme }) => theme.heading.color.secondary};
  margin-bottom: 0;

  .heading {
    display: flex;
    font-size: 38px;
    font-weight: 700;
  }

  .sub-heading {
    color: ${({ theme }) => theme.button.bg.primary};
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
    font-size: 20px;
    margin-top: 0.2em;
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    text-align: center;

    .heading {
      font-size: 30px;
    }

    .sub-heading {
      text-align: center;
    }
  }

  @media (max-width: 450px) {
    font-size: 18px !important;
    font-weight: 600 !important;
  }

  @media (max-width: 388px) {
    .heading {
      font-size: 18px;
      font-weight: 600;
    }
  }
`;
